import { render, staticRenderFns } from "./StackInfo.vue?vue&type=template&id=2026af88&scoped=true"
import script from "./StackInfo.vue?vue&type=script&lang=js"
export * from "./StackInfo.vue?vue&type=script&lang=js"
import style0 from "./StackInfo.vue?vue&type=style&index=0&id=2026af88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026af88",
  null
  
)

export default component.exports